export default __webpack_public_path__ + "static/lo-fly-dirt-bg-c74291e171fa32ebfdf9b946159e59d2.png";